import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints, urlKeys } from 'src/api/APIEndpoints';
import { formatString } from 'src/util/STR';
import { baseQuery } from './baseQuery';

export const eSingApi = createApi({
  baseQuery,
  reducerPath: 'ESingApi',
  endpoints: builder => ({
    setESign: builder.query<any, any>({
      query: ({ site_id, study_id, country, data, application, application_section, application_module_section }) => ({
        url: `${formatString(
          endPoints.ESign.eSign,
          { key: urlKeys.study_id, value: study_id },
          { key: urlKeys.site_id, value: site_id }
        )}?country=${country}&application=${application}&application_section=${application_section}&application_module_section=${application_module_section}`,
        method: 'POST',
        body: data
      })
    })
  })
});

export const { useLazySetESignQuery } = eSingApi;
